import React, { useEffect } from 'react'
import MainRouter from '../../Routers/MainRouter'

import { QueryClientProvider } from 'react-query'
import Header from './Header'
import enLocale from 'date-fns/locale/en-AU'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { appBar, envBar } from '../../garvan-react/Constants/StyleConstants'
import ContentWrapper from '../../garvan-react/Components/ContentWrapper'
import EnvBar from '../../garvan-react/Components/EnvBar'
import { CssBaseline } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import GlobalTriggers from '../../Contexts/GlobalTriggers'
import UserConfig from '../../Contexts/UserConfig'
import MessagePopup from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import CurrentMachine from '../../Contexts/CurrentMachine'
import CurrentHolding from '../../Contexts/CurrentHolding'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import packageJson from '../../../package.json'
import errorSound from '../../Assets/Sounds/error.mp3'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import { Copyright } from '../../garvan-react/Components/Copyright'
import { queryClient } from '../../APIs/QueryClient'

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_PRO!)

const Home = () => {
  const showEnvBar = process.env.REACT_APP_STAGE !== 'production'
  const topOffset = appBar
  const topOffsetEnv = topOffset + (showEnvBar ? envBar : 0)

  // Updating the default Favicon to reflect env
  useEffect(() => {
    ;(async () => {
      //grab favicon element by ID
      const favicon: any = document.getElementById('favicon')!
      if (process.env.REACT_APP_STAGE !== 'Production') {
        favicon.href = '/stuart/favicon-dev.ico'
      } else {
        favicon.href = '/stuart/favicon-prod.ico'
      }
    })()
  }, [])

  return (
    <HelmetProvider>
      <Helmet>
        <title>{`${process.env.REACT_APP_UI_ABBREV ? `[${process.env.REACT_APP_UI_ABBREV}]` : ''} ${packageJson.shortName}`}</title>
      </Helmet>
      <LocalizationProvider
        adapterLocale={enLocale}
        dateAdapter={AdapterDateFns as any}
      >
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <MessagePopup
            errorSound={errorSound}
            api_v={'StuartWeb'}
          >
            <UserConfig>
              {/*User includes ThemeProvider - user choice of colour and mode*/}
              <GlobalTriggers>
                <CurrentMachine>
                  <CurrentHolding>
                    <Header />
                    {showEnvBar && (
                      <EnvBar
                        env={`${process.env.REACT_APP_UI_NAME} ${packageJson.version}`}
                        topOffset={topOffset}
                      />
                    )}
                    <ContentWrapper topOffset={topOffsetEnv}>
                      <MainRouter />
                      <Copyright />
                    </ContentWrapper>
                  </CurrentHolding>
                </CurrentMachine>
              </GlobalTriggers>
            </UserConfig>
          </MessagePopup>
        </QueryClientProvider>
      </LocalizationProvider>
    </HelmetProvider>
  )
}

export default Home
